import * as React from 'react';
import { SVGProps } from 'react';

const SvgTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 23 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.264 20.64c-.396 0-.735-.141-1.017-.423s-.423-.621-.423-1.017V5.52H3.84V4.08h4.512v-.72h6.336v.72H19.2v1.44h-.984V19.2c0 .384-.144.72-.432 1.008s-.624.432-1.008.432H6.264zM16.776 5.52H6.264V19.2h10.512V5.52zM8.808 17.136h1.44V7.56h-1.44v9.576zm3.984 0h1.44V7.56h-1.44v9.576z" />
  </svg>
);

export default SvgTrash;
